<template>
        <CContainer fluid class="mt-1 lg-jbt-app_access2">
            <CRow>
                <CCol>
                    <CInput
                        :value.sync="id"
                        readonly
                        class="m-0"
                        data-lg-command-copy
                    >
                        <template #append>
                            <CButton @click="copy()">
                                <CIcon class="icon" :content="$options.icons.cilCopy"/>
                            </CButton>
                        </template>
                    </CInput>
                </CCol>
            </CRow>
        </CContainer>
</template>

<script>
import { cilCopy } from '@coreui/icons';
export default {
    name: "JumBotronAdvance",
    icons:{
        cilCopy
    },
    props: {
        id: {
        },
    },
    methods:{
        copy(){
            let copyText = this.$el.querySelector('[data-lg-command-copy]');
            /* Select the text field */
            copyText.select();
            copyText.setSelectionRange(0, 99999); /* For mobile devices */

            /* Copy the text inside the text field */
            document.execCommand("copy");
        },
    },
};
</script>
<style lang="scss">
    .lg-jbt2{
        background-color: #ffffff;
        & .display-8{
            font-size: 2rem;
        }
        & .lead{
            font-size: 1rem;
        }

    }

    .lg-jbt-app_access2{
        @extend .lg-jbt2;
        & .form-group{
            width: 100%;
            position: relative;
            & input{
                color: #495057 !important;
                background-color: #e9ecef !important;
                padding: 1.5rem;
                border-radius: 5px 5px 5px 5px;
            }

            & .input-group-append{
                position: absolute;
                z-index: 1600;
                right: -2%;
                top: 50%;

                & button{
                    background-color: white;
                    border-radius: 50px !important;
                }
            }

        }
    }

</style>